// Module
var code = "<div class=\"designer-context-menu\">\n  <ul class=\"dropdown-menu\">\n    <li ng-repeat=\"item in items\" ng-class=\"item.cssClass\">\n      <a ng-click=\"item.action()\">{{::item.text}}</a>\n    </li>\n  </ul>\n</div>\n";
// Exports
module.exports = code;